import { CommonStateEnum } from "./common";
import { User } from "./user";

export enum DocTypeEnum {
    NODE = 1, //节点
    LEAF, //叶子
    LINK, //链接
}

export interface Doc {
    id: string;
    pid: string;
    rootId: string;
    path: string;
    name: string;
    suffix: string;
    fileId: string;
    nodeType: DocTypeEnum;
    subs: Array<Doc>;
    state: CommonStateEnum;
    creator: User;
}

export interface DocAdd {
    pId?: string;
    name: string;
    suffix?: string;
    fileId?: string;
    nodeType: DocTypeEnum;
}
export enum DocsEnum {
    PIC = "1",
    DOC = '2'
}